import api from '@/utils/api';

/**
 * Get  supplier's products by a selected product category
 * @param {string} supplierId - the supplier id
 * @param {string} productCategoryId - the product category id
 * @returns {Promise}
 */
const getSupplierCategoriesByProductCategoryApi = (
  supplierId,
  productCategoryId,
) => {
  const url = `/dealer/${supplierId}/product/filters/${productCategoryId}`;
  return api.get(url);
};

export default getSupplierCategoriesByProductCategoryApi;
